import { ImportModel } from '@bracesDesigner/devRoom/UI/ImportModel.tsx';
import { FillHole } from '@bracesDesigner/devRoom/UI/FillHole.tsx';
import { IconButton } from '@/components/ui/button';
import useThreeInteractionStore from '@/modules/three/hooks/useThreeInteractionStore';
import { SculptTool } from './SculptTool';

export function DevPanelUI() {
  const { activeToolName, setActiveTool } = useThreeInteractionStore();
  const isActive = activeToolName === 'sculpt';
  return (
    <div className={'flex flex-col gap-4 m-10 absolute z-10 left-0 top-0'}>
      <ImportModel />
      <FillHole />
      <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">Sculpt</h2>
          <IconButton onClick={() => setActiveTool(isActive ? null : 'sculpt')}>
            {isActive ? 'Disable' : 'Enable'}
          </IconButton>
        </div>
      {isActive && <SculptTool />}
    </div>
  );
}
